/*
 * Created by jmeo at 2021-05-14
 * FileName: api.ts
 */

const apiHost = '/api'

export default class API {
	static URI_LOGIN = `${apiHost}/dealer/main/dologin`
	static URI_LOGOUT = `${apiHost}/dealer/main/exit`
	// 发送短信验证码 GET phone:string
	static URI_LOGIN_SEND_CODE = `${apiHost}/dealer/main/yzm`
	// 短信验证码登录 POST phone:string, yzm:string
	static URI_LOGIN_CODE = `${apiHost}/dealer/main/yzmlogin`
	// 获取修改密码验证码 GET phone:string
	static URI_PWD_SEND_CODE = `${apiHost}/dealer/user/getEditPwdYzm`
	// 修改密码验证码校验 POST phone:string,yzm:string
	static URI_PWD_CODE_VALIDATE = `${apiHost}/dealer/user/checkEditPwdYzm`
	// 修改密码 POST pwd:string
	static URI_PWD_CHANGE = `${apiHost}/dealer/user/editPwd`

	//获取用户详情
	static URI_USER = `${apiHost}/dealer/main/dealerUserInfo`
	//资格预审
	static URI_QUALIFICATION = `${apiHost}/qualification/listByDealer`
	//分期申请
	static URI_APPLY = `${apiHost}/baseInfo/listByDealer`
	//贷中列表
	static CENTER_LIST = `${apiHost}/loaning/dealerlist`
	//二维码信息
	static QR_CONTENT = `${apiHost}/dealer/user/saleQrCodeToken`
	//客户留资列表
	static PRELOAN_LIST = `${apiHost}/preloanCustomerIntension/list`
	//人员列表
	static ASIGN_MANAGE_LIST = `${apiHost}/qualification/getAsignManagerList`
	//客户留资指派
	static INTENSION_ASIGN = `${apiHost}/preloanCustomerIntension/asign`
	//客户联系标记
	static CONTACK_MARK = `${apiHost}/preloanCustomerIntension/contactMark`
	//金融方案编辑状态
	static EDIT_STATUS = `${apiHost}/loaning/editStatus`
	//金融方案详情
	static PLAN_DETAIL = `${apiHost}/loaning/getFinancePlan`
	//金融方案费率
	static GET_CONFIG = `${apiHost}/loaning/getConfig?code=commissionConfig`
	//车型获取
	static GET_CARE_LIST = `${apiHost}/brandModel/securityModels`
	//省市
	static GET_CITYS = `${apiHost}/sysManager/getArealist`
	//计算方案
	static PLAN_CALE = `${apiHost}/loaning/calcFinancePlan`
	//确认下发
	static CONFIRM_CREATE = `${apiHost}/loaning/createFinancePlan`
	//编辑下发
	static CONFIRM_EDIT = `${apiHost}/loaning/editFinancePlan`
	//推送合同
	static PUSH_CONTRACT = `${apiHost}/loaning/pushContract`
	//合同详情
	static CONTRACK_DETAIL = `${apiHost}/loaning/getContract`
	//上传图片
	static UPLOAD_IMG = `${apiHost}/loan/submitReplenishInfos`
	//放款详情
	static APPLY_DETAIL = `${apiHost}/loaning/getGrantApplyDetail`
	//放款提交
	static APPLY_COMMIT = `${apiHost}/loaning/grantApplyCommit`

	// 资格预审指派
	static ZI_GE_ASIGN = '/api/qualification/asignByDealerManager'

	// 获取验证码
	static ASSURE_GETCODE = `${apiHost}/ignore/guarantee/getStatusData`
	static ASSURE_LOGIN_CODE = `${apiHost}/ignore/guarantee/sendOneYzm`
	// 担保详情 post
	static ASSURE_Detail = `${apiHost}/ignore/guarantee/findByLoaningInfoId`
	// 提交担保人表单 post
	static ASSURE_SUBMIT = `${apiHost}/ignore/guarantee/save`
	// 上传文件 post
	static ASSURE_IMG_UPLOAD = `${apiHost}/ignore/guarantee/uploadFile`
	// 获取区域
	static ASSURE_AREA = `${apiHost}/ignore/guarantee/arealist`

	// 归档资料列表
	static ARCHIVE_LIST = `${apiHost}/Loan/document/dealer/findByParam`
	// 归档项详情
	static ARCHIVE_LIST_ITEM_DETAIL = `${apiHost}/Loan/document/dealer/findById`
	// 归档资料表单保存
	static ARCHIVE_FORM_SAVE = `${apiHost}/Loan/document/dealer/saveLoanDocument`
	// 归档资料表单提交
	static ARCHIVE_FORM_SUBMIT = `${apiHost}/Loan/document/dealer/submitLoanDocument`
	// 归档资料表单
	static ARCHIVE_IMG_UPLOAD = `${apiHost}/loaning/uploadFile`

	// 查询所有融租单
	static URI_ALL_LIST = `${apiHost}/loaning/findAllLoanByDealer`

	// 节假日休息判定
	static API_HOLIDAY_VALIDATE = `${apiHost}/ignore/checkHoliday`

	static API_REBATE = `${apiHost}/lrc/rebate`

}
